import $ from 'jquery';

$('.contact-slider').each((i, elem) => {
    const $slider = $(elem);

    $slider.slick({
        autoplay: false,
        infinite: true,
        arrows: false,
        dots: true,
        draggable: true,
        responsive: [{
            breakpoint: 992,
            settings: {
                draggable: true
            }
        }]
    });
});
